import { AxiosResponse } from "axios";
import { format } from "date-fns";

import { SchedulesOrganicsResponse } from "../interfaces/agendamento";
import { apisiseci, apisso } from "./api";

export const getAgendamentosDiarios = (
  token: string,
  params?: {
    hoje?: boolean;
    anteriores?: boolean;
    status?:
    | "Cancelado"
    | "Finalizado"
    | "Em Atendimento"
    | "Aguardando"
    | "Não Compareceu";
    page?: number;
    unidade?: string;
    guiche_id?: string;
  }
) =>
  apisiseci.get<SchedulesOrganicsResponse>("diario/atendimentos/", {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  });

export const updateStatusAgendamentoDiario = (
  token: string,
  id: number,
  status:
    | "Cancelado"
    | "Finalizado"
    | "Em Atendimento"
    | "Aguardando"
    | "Não Compareceu",
  guiche: string
): Promise<AxiosResponse> =>
  apisiseci.put(
    `diario/atendimentos/${id}/?guiche_id=${guiche}`,
    {
      id,
      status,
      guiche,
    },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

export const addObservationAgendamentoDiario = (
  token: string,
  id: string,
  observation: string
): Promise<AxiosResponse> =>
  apisiseci.post(
    `diario/observacao/`,
    {
      agendamento: id,
      conteudo: observation,
    },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

export const searchAgendamentosDiarios = (
  token: string,
  params?: {
    data?: string;
    cpf?: string;
    status?:
    | "Cancelado"
    | "Finalizado"
    | "Em Atendimento"
    | "Aguardando"
    | "Não Compareceu";
    page?: number;
  }
) =>
  apisiseci.get<SchedulesOrganicsResponse>("diario/consulta/", {
    headers: {
      Authorization: `Token ${token}`,
    },
    params,
  });

export const gerarAtendimentoOrganico = (
  token: string,
  nome: string,
  cpf: string,
  servico: number,
  setor: number,
  unidade: string,
) => apisiseci.post('diario/agendar/', {
  nome,
  cpf,
  servico,
  setor,
  unidade,
  tipo: "Portal",
  para_dependente: false,
}, {
  headers: {
    Authorization: `Token ${token}`,
  },
});

export const agendamentoOrganico = (
  token: string,
  nome: string,
  cpf: string | null,
  servico: number,
  setor: number,
  tipo: string,
  hora: string | null,
  unidade_slug: string,
  para_dependente: boolean,
  documento: string | null,
  tipo_documento: 'cpf' | 'rg' | 'titulo' | 'nenhum',
  date?: Date,
) => {
  const dateScheduler = date && format(date, 'yyyy-MM-dd');
  return apisiseci.post('/diario/agendar/', {
    nome,
    cpf,
    servico,
    setor,
    tipo,
    hora,
    unidade: unidade_slug,
    para_dependente,
    documento,
    tipo_documento,
    data: dateScheduler
  }, {
    headers: {
      Authorization: `Token ${token}`
    }
  }
  )
};

export const checarHorarios = (
  token: string,
  id_servico: number,
  unidade_slug: string,
  data?: Date
) => {
  let url = '';
  const dateFormatted = data && format(data, 'yyyy-MM-dd');
  if (data) {
    url = `/diario/checar_horarios/?servico=${id_servico}&unidade=${unidade_slug}&data=${dateFormatted}`;
  } else {
    url = `/diario/checar_horarios/?servico=${id_servico}&unidade=${unidade_slug}`;
  }
  return apisiseci.get(url, {
    headers: {
      Authorization: `Token ${token}`
    }
  })
}

export const checarHorariosWithDate = (
  date: Date,
  unity: string,
  serviceID: number,
  token: string,
): Promise<AxiosResponse> => {
  const dateScheduler = format(date, 'yyyy-MM-dd');

  return apisiseci
    .get(`agendamento/checar_horarios/?data=${dateScheduler}&servico=${serviceID}&unidade=${unity}`, {
      headers: {
        Authorization: `Token ${token}`
      }
    }
    );
};

type checharCPFProps = {
  cpf: string
}

export const checarCpf = ({ cpf }: checharCPFProps): Promise<AxiosResponse> => {
  return apisso.post(`/admin/checar/cpf/`, { cpf });
};
